
import { defineComponent } from 'vue'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import { VCodeMirror } from 'vue3-code-mirror'
import useValidate from '@vuelidate/core'
import sparqlDescriptor from './DatasetManagementSparqlDataset.json'
import Card from 'primevue/card'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'

export default defineComponent({
    components: { Card, VCodeMirror, KnValidationMessages },
    props: { selectedDataset: { type: Object as any } },
    emits: ['touched'],
    data() {
        return {
            sparqlDescriptor,
            dataset: {} as any,
            v$: useValidate() as any,
            codeMirrorSparql: {} as any,
            sparqlOptions: {
                mode: 'application/sparql-query',
                lineWrapping: true,
                indentWithTabs: true,
                smartIndent: true,
                matchBrackets: true,
                theme: 'eclipse',
                lineNumbers: true
            }
        }
    },
    created() {
        this.loadDataset()
        this.setupCodeMirror()
    },
    watch: {
        selectedDataset() {
            this.loadDataset()
        }
    },
    validations() {
        const sparqlFieldsRequired = (value) => {
            return this.dataset.dsTypeCd != 'SPARQL' || value
        }
        const customValidators: ICustomValidatorMap = { 'sparql-fields-required': sparqlFieldsRequired }
        const validationObject = { dataset: createValidations('dataset', sparqlDescriptor.validations.dataset, customValidators) }
        return validationObject
    },
    methods: {
        loadDataset() {
            this.dataset = this.selectedDataset
            this.dataset.sparqlQuery ? '' : (this.dataset.sparqlQuery = '')
        },
        setupCodeMirror() {
            this.$refs.codeMirrorSparql ? (this.codeMirrorSparql = (this.$refs.codeMirrorSparql as any).editor as any) : ''
        }
    }
})
